// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 781 ? "form-schema-jsuites" : chunkId) + "." + {"781":"06778531","820":"e9e721f8"}[chunkId] + ".chunk.css";
};